// unsubscribePrivateStreamViewerV2Channel.js
'use strict';
import getMeData from '../selector/getMeData.js';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
import { PRESET_SD } from '../resource/liveStreamConstants.js';

/**
 * Unsubscribe private stream viewer v2 channel
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {preset} - stream preset.
 * @return {Promise} Action promise.
 */
const unsubscribePrivateStreamViewerV2Channel =
  ({ streamId, preset = PRESET_SD }) =>
  async (dispatch, getState) => {
    const userId = getMeData(getState(), 'id');

    return sendMessageToSW({
      type: MessageTypes.UNSUBSCRIBE_PRIVATE_STREAM_VIEWER_V2_CHANNEL,
      payload: {
        streamId,
        preset,
        userId,
      },
    });
  };

export default unsubscribePrivateStreamViewerV2Channel;
